import { formatDateForMySQL } from "components/formatDate";
import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const ActionHandler = async (estimateID,token,Request,Reason = "") => {
  //const accesstoken = getToken();

  if (token && estimateID > 0 && Request) {
    try {         

      const response = await fetch(`${dev_baseUrl}/Estimate/${Request}?estimateID=${estimateID}&token=${token}${Reason === ""? '' : '&&reason='+Reason}`, {
        method: 'GET'                
      });      
      const data = await response.json();                      
      if (!response.ok && data.isError) {
        return data;
      } else if(response.ok && !data.isError ){      
        return data;
      }       
    } catch (error) {
      console.error('Network error:', error);
      return { isError:true, message: 'An error occurred. Please try again later.' , error: error};
    }
  } else {
    console.warn('Access token is not available.');
    return { isError:true, message: 'An error occurred. Please try again later.'};
  }
};

